module.exports = {"audiences":["allMembers"],"experimentVersion":"v2","experimentAllocation":0.5,"defaultWeight":1,"defaults":{"showBanner":false},"autoTrack":true,"variations":[{"name":"showBanner","weight":1,"values":{"showBanner":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/notifyOverdueTeams.json
// module id = ydc3
// module chunks = 2